import "@fontsource/zen-kaku-gothic-new/300.css";
import "@fontsource/zen-kaku-gothic-new/400.css";
import "@fontsource/zen-kaku-gothic-new/700.css";
import "./src/styles/global.css";

import * as React from "react";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { CustomTheme } from "./src/utils/theme";

export const wrapRootElement = ({ element }: { element: JSX.Element }) => {
  return (
    <ThemeProvider theme={CustomTheme}>
      <CssBaseline />
      {element}
    </ThemeProvider>
  );
};
